import Vue from "vue";
import App from "./components/App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "@/assets/css/reset.css";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/element-ui.scss";
import "@/assets/css/common.scss";
import "@/assets/css/style.css";
import "@/assets/css/style.css";
import "@/assets/css/swiper.min.scss";
//公共函数：请求函数
import {
	getRequest,
	postRequest,
	deleteRequest,
	putRequest,
	uploadFileRequest
} from "./api/http";

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
import InputNumberRange from '@/views/Common/inputNumberRange.vue'
Vue.component(InputNumberRange.name, InputNumberRange)


import {
	showLoading,
	hideLoading
} from "@/assets/js/loading";
Vue.prototype.showLoading = showLoading;
Vue.prototype.hideLoading = hideLoading;

import {
	HTMLDecode
} from "@/assets/js/common";
Vue.prototype.HTMLDecode = HTMLDecode;

import downloadfile from "@/assets/js/common";
Vue.use(downloadfile);

import {
	baseToken,
	baseURL
} from '@/api/common_obj'
Vue.prototype.baseToken = baseToken;
Vue.prototype.baseURL = baseURL;

Vue.config.productionTip = false;
Vue.use(ElementUI, {
	size: "mini",
	fontSize: "13px"
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");